// extracted by mini-css-extract-plugin
module.exports = {"contentIdentification":"Identification_contentIdentification__1nYyd","divider":"Identification_divider__3lq-_","button":"Identification_button__1bIbH"};